/* Axios */
import axios from "axios";

/* Configuration des URLs et authentification */
export const BASE_URL = process.env.REACT_APP_LOCAL_API_BASE_URL;
export const BASIC_AUTH = process.env.REACT_APP_OEF_IFRAME_AUTH;

/**
 * Crée une instance axios avec jeton d'authentification.
 *
 * @param {string} authToken Jeton d'authentification.
 * @returns {axios.AxiosInstance} Instance axios configurée avec jeton d'authentification.
 */
export const axiosPrivate = (authToken) => {
  if (!authToken) {
    console.warn('Token d\'authentification manquant');
  }

  return axios.create({
    baseURL: BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Basic ${authToken}`
    }
  });
};

/**
 * Gestion centralisée des erreurs.
 *
 * @param {Error} error Erreur retournée par axios.
 * @returns {object} Objet d'erreur formaté.
 */
const handleError = (error) => {
  if (error.response) {
    // Le serveur a répondu avec un code d'erreur
    console.error('Erreur de réponse:', error.response.status, error.response.data);
    return {
      success: false,
      status: error.response.status,
      message: error.response.data?.message || 'Erreur du serveur',
      data: error.response.data
    };
  } else if (error.request) {
    // La requête a été envoyée mais aucune réponse n'a été reçue
    console.error('Erreur de requête:', error.request);
    return {
      success: false,
      message: 'Aucune réponse du serveur',
      error: error.message
    };
  } else {
    // Erreur lors de la configuration de la requête
    console.error('Erreur:', error.message);
    return {
      success: false,
      message: error.message
    };
  }
};

/**
 * AXIOS POST request sécurisée par jeton.
 *
 * @param {string} url URL de la route à appeler.
 * @param {object} body Données envoyées dans le corps de la requête.
 * @param {string} [authToken] Jeton d'authentification (utilise BASIC_AUTH si non fourni).
 * @returns {Promise<object>} Réponse de l'API ou erreur formatée.
 */
export function postRequest(url, body, authToken) {
  const token = authToken || BASIC_AUTH;

  return axiosPrivate(token)
    .post(url, body)
    .then((response) => response.data)
    .catch((error) => handleError(error));
}

/**
 * AXIOS GET request sécurisée par jeton.
 *
 * @param {string} url URL de la route à appeler.
 * @param {string} [authToken] Jeton d'authentification (utilise BASIC_AUTH si non fourni).
 * @returns {Promise<object>} Réponse de l'API ou erreur formatée.
 */
export function getRequest(url, authToken) {
  const token = authToken || BASIC_AUTH;

  return axiosPrivate(token)
    .get(url)
    .then((response) => response.data)
    .catch((error) => handleError(error));
}

